<template>
  <div class="news_content4">
    <div class="div-img-top div-m body-width divcss5">
      <div class="font_zh">{{$t("news.newsinfomation")}}</div>
      <div class="font_en font_en_top">NEWS INFORMATION</div>
    </div>
    <div class="row news_content">
      <div class="div-top body-width divcss5">
        <div>
          <div @click="setroters()">
            <img class="news_img" src="../../../assets/images/news1/news1.png" />
          </div>
          <div class="news_content">
            <div class="div-float">
              <div class="news-Black-24">08</div>
              <div class="news-Regular-14">2019.05</div>
            </div>
            <div class="div-float1 news_content2 news-Regular-18 div-show">
              <a @click="setroters()">大连海大智龙科技有限公司举行揭牌仪式</a>
            </div>
            <div class="news_content1 news-Regular-14 div-show">
              <a @click="setroters()">5月8日上午，由学校尹勇教授团队“高品质航海模拟器及其开发平台系统</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex'
export default {
  name: "newspartcontent",
  data() {
    return {
      header:{
          showindex:false,
          showabout:false,
          showproduct:false,
          shownews:true,
          showjoin:false,
          showpartner:false,
          showcontact:false,
          showlanguage:false,
        }
    };
  },
  methods: {
    ...mapMutations(['setHeaderTitle']),
    setroters() {
      this.switchStyle()
      this.$router.push({
        path: "newscontent",
        query: {
          id: 1
        }
      });
    },
    switchStyle(){
        this.setHeaderTitle(this.header);
      }
  },
  created() {
  }
};
</script>
<style scoped>
.news_content4 {
  margin-bottom: -180px;
}
.news_content {
  padding-top: 8px;
  padding-bottom: 0px;
}

.news_content1 {
  padding-top: 5px;
  padding-bottom: 0px;
}

.news_content2 {
  padding-top: 3px;
  padding-bottom: 0px;
}

.news_more {
  padding: 0 auto;
  border: 1px dashed #e6e6e6;
}

.news_more div {
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  color: #666666;
  width: 60px;
  height: 30px;
  border: dashed #ffffff 1px;
}

.news_more a:hover {
  background: #ffffff;
  color: #2d79be;
}

/*字体*/
.font_zh {
  font-size: 24px;
  color: #0d3e88;
}

.font_en {
  font-size: 16px;
  color: #2e79be;
}

.div-float {
  float: left;
  border-right: 1px solid #dfe1e3;
  width: 20%;
}

.div-float1 {
  float: left;
  width: 80%;
}

.div-top {
  background-color: #fbfbfb;
  margin-top: 40px;
  margin-bottom: 200px;
  width: 380px;
  height: 270px;
  box-shadow: 0px 1px 1px #dfe1e3;
  opacity: 1;
}

.news_img {
  width: 100%;
  height: 200px;
}

.div-show {
  padding-left: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.div-m {
  margin-top: 85px;
}
.news_class {
  cursor: pointer;
  opacity: 0.5;
  color: #2e79be;
}
.news_class1 {
  cursor: pointer;
}
.news_content a:hover {
  color: #2e79be;
}
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/indexcontentcoms/newspartcontent.vue